var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDecrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 8,
    height: 2,
    viewBox: "0 0 8 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14363 0.428146C0.826592 0.428146 0.571777 0.682961 0.571777 0.999998C0.571777 1.31704 0.826592 1.57185 1.14363 1.57185H6.85919C7.17622 1.57185 7.43104 1.31704 7.43104 0.999998C7.43104 0.682961 7.17622 0.428146 6.85919 0.428146",
    fill: "#1C1C1C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrease);
export default __webpack_public_path__ + "static/media/decrease.c1e5b4b663ffefd11dbf3961724b1f7b.svg";
export { ForwardRef as ReactComponent };